import { Component, ElementRef, Renderer2, forwardRef, Inject } from '@angular/core';
import { ScrollComponent } from "sharedFeatures/scroll";
import { XeroService } from 'sharedFeatures/sharedServices';
import { XeroCompany } from 'sharedFeatures/sharedModels';
import { dialogCreationActions } from "sharedFeatures/store";
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { NewPlanInnerForm } from '../newplan-inner.form';
import { NewPlanForm } from '../newplan.form';
import { NewPlanFormBodyComponent } from '../newplan-body.component';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { LoadingSpinnerService } from 'sharedGuiSmall/sharedServices/loadingSpinner.service';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'choose-company-form-body',
    templateUrl: './choose-company-form-body.component.html',
    styleUrls: ['./choose-company-form-body.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, TranslateModule]
})
export class ChooseCompanyFormBodyComponent extends NewPlanInnerForm {

    isShowClose = true;
    protected xeroService: XeroService;
    companies: Array<XeroCompany> = [];
    currentCompanyId: string = '';
    selectedCompanyId: string = '';
    app: any;

    constructor(
        el: ElementRef,
        r: Renderer2,
        xeroService: XeroService,
        @Inject(forwardRef(() => NewPlanForm)) protected parent: NewPlanForm,
        private loadingSpinnerService: LoadingSpinnerService
    ) {
        super(el, r);
        this.xeroService = xeroService;

        var fromAccount = window.isFromAccount;
        if (!fromAccount)
            this.app = window["main_app"];
        else
            this.app = window["account_app"];
    }

    ngOnChanges() {

    }

    ngOnDestroy(): void {
        dialogCreationActions.setNewPlanDialogOpen(false);
    }

    ngAfterViewInit() {
        this.loadCompaniesList();
    }

    loadCompaniesList(failureFn?: Function): void {

        let elem = this.getElDom();
        let areaLoading = this.loadingSpinnerService.getAreaLoadingDiv(elem, '.loadingio-spinner-rolling-vo35qopy26');

        if (areaLoading) 
            jQuery(areaLoading).show();

        this.xeroService.GetCompaniesList().then((GetCompaniesListResult) => {
            if (typeof (GetCompaniesListResult.success) == "undefined") return;

            if (GetCompaniesListResult.success) {

                let connectMode = localStorage.getItem('isConnectToXero') !== '0' ? 'existingplan' : 'newplan';

                if (GetCompaniesListResult.XeroAuthenticationSuccessfull) {
                    this.companies = JSON.parse(GetCompaniesListResult.CompaniesList);
                    DomSmallUtils.setStyle(this.r, areaLoading, 'display', 'none');
                    this.currentCompanyId = GetCompaniesListResult.CurrentCompanyId;
                    this.selectedCompanyId = this.currentCompanyId;

                    let selectedCompany = this.companies.find(x => x.selected);

                    if (selectedCompany) {
                        if (connectMode === 'existingplan')
                            localStorage.setItem('company', selectedCompany.name);

                        this.selectClick(selectedCompany);
                    }
                    else {
                        // redirect to Xero OAuth2
                        this.app.handleXeroAuthenticationUnsuccessfulError("/?connectMode=" + connectMode + "&forceConnect=true");
                    }

                }
                else {
                    // redirect to Xero OAuth2
                    this.app.handleXeroAuthenticationUnsuccessfulError("/?connectMode=" + connectMode + "&forceConnect=true");
                }
            }
            else {
                if (failureFn) failureFn();
            }

        });

    }

    public onGoOut(callback: Function): void {

        if (this.currentCompanyId != this.selectedCompanyId) {

            this.xeroService.ChangeCurrentCompany(this.selectedCompanyId).then((res) => {
                if (typeof (res.success) == "undefined") return;

                if (res.success) {
                    this.currentCompanyId = this.selectedCompanyId;
                    var body = <NewPlanFormBodyComponent>this.parent.getBodyComponent();
                    body.reloadAccountMatchings();
                    if (callback) callback();
                }
                else {
                    this.parent.close();
                }
            });

        }
        else {
            if (callback) callback();
        }

    }

    public IsDayLimitReached(company: XeroCompany): boolean {
        if (company.xeroLimits) 
            return company.xeroLimits.XDayLimitRemaining <= 50;
        
        return false;
    }

    public reload(callback?: Function) {

    }

    public getScrollPane(): ScrollComponent {
        throw new Error("Method not implemented.");
    }
    public saveClosePanePlaceEl(): Element {
        throw new Error("Method not implemented.");
    }

    onClose() {

        this.parent.showSetupWarning();

    }

    selectClick(company: XeroCompany) {
        this.companies.forEach((c) => {
            c.selected = false;
            if (c.companyId == company.companyId) {
                c.selected = true;
                this.selectedCompanyId = company.companyId;                

                var body = <NewPlanFormBodyComponent>this.parent.getBodyComponent();
                body.UpdateNewPlanData(company);                
            }
        });
    }

    connectNew() {
        var body = <NewPlanFormBodyComponent>this.parent.getBodyComponent();

        let connectMode = "newplan";

        if (body.isConnectToExistingModeEnabled)
            connectMode = "existingplan";

        document.location.href = `${window.xeroConnectUrl}/?connectMode=${connectMode}&forceConnect=true&fromAccount=${window.isFromAccount}`;
    }


}
